<template>
<div class="max-width">
    <el-row :gutter="20">
        <el-col :span="12" :xs="24">
            <div class="singlePage-title">{{currentCommunitGroup.groupName}}</div>
        </el-col>
        <el-col :span="12" :xs="24" class="time mb-10">
            {{ this.$moment().tz('Asia/Taipei').format('YYYY/MM/DD HH:mm') }}
        </el-col>
    </el-row>


    <div class="singlePage-row">
        <el-radio-group class="water-tab" v-model="sheetRadioBtn">
            <el-radio-button label="公共水質"></el-radio-button>
            <el-radio-button label="公共用水"></el-radio-button>
            <el-radio-button label="住戶用水"></el-radio-button>
        </el-radio-group>
        <div class="chart-tag">
            <div class="tag-item">
                <div class="tag-icon tag-color-1"></div>
                <p>正常</p>
            </div>
            <div class="tag-item">
                <div class="tag-icon tag-color-2"></div>
                <p>斷訊</p>
            </div>
            <div class="tag-item">
                <div class="tag-icon tag-color-3"></div>
                <p>疑似漏水</p>
            </div>
            <div class="tag-item">
                <div class="tag-icon tag-color-4"></div>
                <p>水質異常</p>
            </div>
        </div>
    </div>

    <!--公共水質-->
    <el-card class="box-card water-block" v-loading="loading" v-if="sheetRadioBtn=='公共水質'">
        <el-row :gutter="20">
            <el-col v-for="(item, index) in monitorData" :key="index" :span="6" :xs="12">
                <div class="tag-icon tag-color-1"></div>
                <!-- <p>{{ item.name }}</p> -->
                <p><a @click="routerPush(item.waterId, item.waterNum, item.meterNum)">{{ item.name }}</a></p>
            </el-col>
        </el-row>
    </el-card>
    <!--公共用水-->
    <el-card class="box-card water-block" v-loading="loading" v-if="sheetRadioBtn=='公共用水'">
        <el-row :gutter="20">
            <el-col v-for="(item) in displayPublicFaucetData" :key="item.waterId" :span="6" :xs="12">
                <span class="tag-icon tag-color-1"></span>
                <p><a @click="routerPush(item.waterId, item.waterNum, item.meterNum)">{{ item.address }}</a></p>
            </el-col>
        </el-row>
    </el-card>
    <!--住戶用水-->
    <el-card class="box-card water-block" v-loading="loading" v-if="sheetRadioBtn=='住戶用水'">
        <el-row :gutter="20">
            <el-col v-for="(item) in displayPrivateFaucetData" :key="item.waterId" :span="6" :xs="12">
                <div class="tag-icon tag-color-1"></div>
                <p><a @click="routerPush(item.waterId, item.waterNum, item.meterNum)">{{ item.address }}</a></p>
            </el-col>
        </el-row>
        <div class="align-center ">
            <el-checkbox v-model="autoPlay" label="輪播" size="default" class="mr-20" />
            <el-button type="default" @click="prevPage" icon="el-icon-caret-left" size="mini" style="font-size: 20px; padding: 0px;"></el-button>
            <span class="page-number">
                第<label>{{ currentPage }}</label>/<label>{{ totalPage }}</label>頁
            </span>
            <el-button type="default" @click="nextPage" icon="el-icon-caret-right" size="mini" style="font-size: 20px; padding: 0px;"></el-button>
            <!-- <img id="prevPage" class="no-margins clickable" src="@/assets/images/prev.png" alt="上一頁" @click="prevPage">
            <span class="page-number">
            第<label>{{ currentPage }}</label>/<label>{{ totalPage }}</label>頁
            </span>
            <img id="nextPage" class="no-margins clickable" src="@/assets/images/next.png" alt="下一頁" @click="nextPage"> -->
        </div>
    </el-card>
</div>
</template>
<script>
import _ from 'lodash'

export default {
    name: 'CommunityGroupList',
    data() {
        return {
            loading: false,
            privateFaucetData:[],
            publicFaucetData:[],
            displayPrivateFaucetData:[],
            displayPublicFaucetData:[],
            monitorData:[],
            autoPlay: true,  // 是否自動播放
            currentPage: 1,  // 當前頁面
            totalPage: 1,  // 總頁數
            timer: null,  // 定時器
            pageSize: 60,
            currentTime: this.$moment().tz('Asia/Taipei').format('YYYY/MM/DD HH:mm'),
            sheetRadioBtn:[]
        }
    },
    computed: {
        currentCommunitGroup() {
            let result = ''
            if(localStorage.getItem('accountType').toLowerCase() == "group") {
                result = JSON.parse(localStorage.getItem('currentProfileGroup'))
            } else if(localStorage.getItem('accountType').toLowerCase() == "unit") {
                result = JSON.parse(localStorage.getItem('currentCommunitGroup'))
            }            
            return result
        }
    },
    watch: {
        sheetRadioBtn(newVal) {
            // 非住戶用水頁籤時，停用自動播放功能
            if(newVal == '住戶用水') {
                this.autoPlay = true
            } else {
                this.autoPlay = false
            }

            this.currentPage = 1    // 公用用水會出現在第一頁，因此切換時切到第一頁
        },
        autoPlay(newVal) {
            if (newVal) {
                this.startAutoPlay();
            } else {
                this.stopAutoPlay();
            }
        },
        currentPage(newVal) {
            // this.displayPrivateFaucetData = this.privateFaucetData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
            this.getFaucetDataByPage(this.pageSize, newVal)
        }
    },
    async created()
    {
    },
    async mounted() {
        //預設顯示公共水質sheet
        this.sheetRadioBtn = '住戶用水';

        localStorage.setItem('CommunityGroupList_ver', '2023-06-02 14:30 changed.')
        await this.getCommunityData()

        if (this.autoPlay) {
            this.startAutoPlay();
        }
    },
    beforeDestroy() {
        this.stopAutoPlay();
    },
    methods: 
    {
        // 取得社區清單資料
        async getCommunityData()
        {
            // await this.getFaucetData()
            await this.getFaucetDataByPage(this.pageSize, this.currentPage)
            this.getAllMonitorData(this.currentCommunitGroup.groupId)
        },
        
        // 取得用水清單
        async getFaucetData()
        {
            // 依照GroupId取得群組用水清單
            let url = "/api/system/communityProfiles/" + this.currentCommunitGroup.groupId
            this.loading = true
            await this.axios.get(url).then( async (res) =>
            {
                const _content = res.data.content
                if(_.isArray(_content))
                {
                    // 收集WaterNum以取得水質資料
                    const waterNumList = []
                    _.forEach(_content, e => {
                        if(!waterNumList.includes(e.waterNum)) {
                            waterNumList.push(e.waterNum)
                        }
                    })

                    await this.getMonitorData(waterNumList)

                    // 公共用水
                    this.publicFaucetData = _content.filter(e => 
                        e.usage === 'public'
                    )

                    // 公共用水-每頁資料
                    this.displayPublicFaucetData = this.publicFaucetData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)

                    // 住戶用水
                    this.privateFaucetData = _content.filter(e => 
                        e.usage === 'private'
                    )

                    // 住戶用水-每頁資料
                    this.displayPrivateFaucetData = this.privateFaucetData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)

                    // 總頁數
                    if(this.privateFaucetData.length > this.pageSize) {
                        this.totalPage = Math.ceil(this.privateFaucetData.length / this.pageSize)   // 無條件進位
                    }
                }
                else
                {
                    this.$message({ message: '無法擷取資料!', type: 'warning' }) 
                }
            })
            .catch( () =>
            {
                this.$message({ message: '無法擷取資料!', type: 'warning' })
            })
            .finally( () =>
            {
                this.loading = false
            })

        },

        // 取得用水清單
        async getFaucetDataByPage(size, page)
        {
            // 清空顯示資料
            this.displayPrivateFaucetData = []

            // 依照GroupId取得群組用水清單
            let url = "/api/system/communityProfiles/" + this.currentCommunitGroup.groupId
            url += "?size=" + size
            url += "&page=" + (page - 1)    // Page從0開始計算
            this.loading = true
            await this.axios.get(url).then( async (res) =>
            {
                const _content = res.data.content
                if(_.isArray(_content))
                {
                    // // 收集WaterNum以取得水質資料
                    // const waterNumList = []
                    // _.forEach(_content, e => {
                    //     if(!waterNumList.includes(e.waterNum)) {
                    //         waterNumList.push(e.waterNum)
                    //     }
                    // })

                    // await this.getMonitorData(waterNumList)

                    // 公共用水
                    this.publicFaucetData = _content.filter(e => 
                        e.usage === 'public'
                    )

                    // 公共用水-每頁資料
                    this.displayPublicFaucetData = this.publicFaucetData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)

                    // 住戶用水
                    this.privateFaucetData = _content.filter(e => 
                        e.usage === 'private'
                    )

                    // 目前切頁由後端處理，因此直接顯示API回傳資料
                    this.displayPrivateFaucetData = this.privateFaucetData
                    // 依照API回傳的總頁數為主
                    this.totalPage = res.data.totalPages

                    // // 住戶用水-每頁資料
                    // this.displayPrivateFaucetData = this.privateFaucetData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)

                    // // 總頁數
                    // if(this.privateFaucetData.length > this.pageSize) {
                    //     this.totalPage = Math.ceil(this.privateFaucetData.length / this.pageSize)   // 無條件進位
                    // }
                }
                else
                {
                    this.$message({ message: '無法擷取資料!', type: 'warning' }) 
                }
            })
            .catch( () =>
            {
                this.$message({ message: '無法擷取資料!', type: 'warning' })
            })
            .finally( () =>
            {
                this.loading = false
            })

        },

        // 取得水質清單
        async getMonitorData(waterNumList)
        {

            _.forEach(waterNumList, async (e) => {
                // 取得指定水號的監測模組資料
                let url = "/api/system/monitor/waterNum/" + e

                await this.axios.get(url).then( res =>
                {
                    if(res.data) {
                        if(_.isArray(res.data) && res.data.length > 0) {
                            _.forEach(res.data, e => {
                                this.monitorData.push(e)
                            })
                        }
                    } else {
                        this.$message({ message: '無法擷取資料!', type: 'warning' })
                    }
                })
                .catch( () =>
                {
                    this.$message({ message: '無法擷取資料!', type: 'warning' })
                })
                .finally( () =>
                {

                })
            })

        },
        // 取得全部水質清單
        async getAllMonitorData(groupId)
        {
            // 清空原有的水質資料
            this.monitorData = []

            // 取得公宅內的監測模組清單
            let url = "/api/system/monitor/communityProfiles/" + groupId

            await this.axios.get(url).then( res =>
            {
                const _content = res.data.content
                if(_content) {
                    if(_.isArray(_content) && _content.length > 0) {
                        _.forEach(_content, e => {
                            this.monitorData.push(e)
                        })
                    }
                } else {
                    this.$message({ message: '無法擷取資料!', type: 'warning' })
                }
            })
            .catch( () =>
            {
                this.$message({ message: '無法擷取資料!', type: 'warning' })
            })
            .finally( () =>
            {

            })

        },

        routerPush(waterId, waterNum, meterNum)
		{
			let currentProfile = {
						waterId: waterId,
						waterNum: waterNum,
						meterNum: meterNum
					}
			localStorage.setItem('currentProfile', JSON.stringify(currentProfile))
			this.$router.push('/profile')
		},

        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },

        nextPage() {
            if (this.currentPage < this.totalPage) {
                this.currentPage++;
            }
        },

        startAutoPlay() {
            this.timer = setInterval(() => {
                if (this.currentPage < this.totalPage) {
                    this.currentPage++;
                } else {
                    this.currentPage = 1;
                }
            }, 10000);
        },
        stopAutoPlay() {
            clearInterval(this.timer);
            this.timer = null;
        },
    }
}
</script>